import React, { useState } from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { ButtonText, SearchInput, useToast } from '@morressier/alembic';
import { searchVars } from '@publishing-engine/email-service/src/entities/TemplateVariables';
import { getOrganizationEmailTemplateVariables } from '../api/email-service';
import { useQuery } from '@tanstack/react-query';
import { useWorkspace } from '../pages/Organization/Workspace/SubmissionContexts/Users/userHook';
import Loading from '../pages/Status/Loading';

export type VarDesc = { var: string; desc: string };

interface TemplateVariablesListProps {
  onCopy?: () => void;
}

const TemplateVariablesList: React.FC<TemplateVariablesListProps> = ({
  onCopy
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [copied, setCopied] = useState<string | null>(null);
  const toast = useToast();
  const { orgId } = useWorkspace();

  const { data: templateVariableList } = useQuery({
    queryKey: ['template-variables', orgId],
    queryFn: () => getOrganizationEmailTemplateVariables(orgId),
    enabled: !!orgId
  });

  if (!templateVariableList || !templateVariableList.length) {
    return <Loading />;
  }

  const filteredList = searchTerm
    ? searchVars(templateVariableList, searchTerm)
    : templateVariableList;

  const handleCopy = async (variable: string) => {
    await navigator.clipboard.writeText(`{{${variable}}}`);
    setCopied(variable);
    if (onCopy) {
      toast({
        variant: 'success',
        title: 'Copied',
        isClosable: true
      });
      onCopy();
    }
    setTimeout(() => setCopied(null), 1000);
  };

  return (
    <>
      <SearchInput
        placeholder="Search variables"
        value={searchTerm}
        name="search"
        onInputClear={() => setSearchTerm('')}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <Box
        style={{
          overflowY: 'auto',
          maxHeight: '24rem'
        }}
      >
        {filteredList.map(v => (
          <Box key={v.var} mb={4}>
            <Flex align="center" justify="space-between" mb={1}>
              <Text textStyle="headingItem" as="div" color="">
                {`{{${v.var}}}`}
              </Text>
              <ButtonText
                variant="primary"
                size="sm"
                onClick={() => handleCopy(v.var)}
              >
                {copied === v.var ? 'Copied' : 'Copy'}
              </ButtonText>
            </Flex>
            <Text as="div" textStyle="textBody">
              {v.desc}
            </Text>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default TemplateVariablesList;
